import {
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  Tooltip,
} from '@chakra-ui/react';
import { IconArrowInbox } from 'central-icons/IconArrowInbox';

import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import { isScreenerV2Page } from '../../utils/routing-helpers';
import { usePageExport } from '../Chart/chart-menu/PageExportProvider';
import {
  usePageConfig,
  useTabContentConfig,
} from '../PageConfigProvider/PageConfigProvider';
import { PageType, RevelioPageId } from '../PageConfigProvider/types';
import { ShareReportMenuItem } from '../SharedReport/ShareReportModal';
import { DataExportMenuItem } from './DataExportMenuItem';
import { PdfExportMenuItem } from './PdfExportMenuItem';
import { PptExportMenuItem } from './PptExportMenuItem';
import { PrintToPdfMenuItem } from './PrintToPdfMenuItem';
import { ScreenerDataExportMenuItem } from './ScreenerDataExportMenuItem';
import { TalentDiscoveryDataExportMenuItem } from './TalentDiscoveryDataExportMenuItem';
import { TalentDiscoverySelectedDataExportMenuItem } from './TalentDiscoverySelectedDataExportMenuItem';

const EXPERIMENTAL_PRINT_TO_PDF_ENABLED = false;

export const DownloadMenuButton = () => {
  const { revelioPageId } = useTabContentConfig();
  const isTalentDiscoveryPage =
    revelioPageId === RevelioPageId.TALENT_DISCOVERY;
  const isScreenerPage = isScreenerV2Page(revelioPageId);

  const { config: pageConfig } = usePageConfig();
  const { isPageDataReady } = usePageExport();
  const isSharedReportsEnabled = useUnleashFlag(FeatureFlag.SharedReports);
  const isNewDashboardLayout = useUnleashFlag(FeatureFlag.DashboardNewLayout);

  const isReportPage = pageConfig.type === PageType.REPORT;
  const isButtonDisabled = isReportPage && !isPageDataReady;
  const showShareMenuItem = isReportPage && isSharedReportsEnabled;

  return (
    <Menu placement="bottom-end">
      <Tooltip
        label={isButtonDisabled ? 'Preparing download...' : 'Download'}
        hasArrow
        animation="none"
        variant="label"
        openDelay={300}
      >
        <MenuButton
          as={IconButton}
          variant={isNewDashboardLayout ? 'flat' : 'outline'}
          rounded="full"
          colorScheme="gray"
          icon={<IconArrowInbox size={16} />}
          aria-label="More actions"
          data-testid="download-menu-button"
          isDisabled={isButtonDisabled}
        />
      </Tooltip>
      <MenuList>
        {isTalentDiscoveryPage && <TalentDiscoveryDataExportMenuItem />}
        {isTalentDiscoveryPage && <TalentDiscoverySelectedDataExportMenuItem />}
        {isScreenerPage && <ScreenerDataExportMenuItem />}
        <PdfExportMenuItem />
        {EXPERIMENTAL_PRINT_TO_PDF_ENABLED && <PrintToPdfMenuItem />}
        <DataExportMenuItem />
        <PptExportMenuItem />
        {showShareMenuItem && <ShareReportMenuItem />}
      </MenuList>
    </Menu>
  );
};
